
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/ai-song-generator",
      function () {
        return require("private-next-pages/ai-song-generator/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/ai-song-generator"])
      });
    }
  